import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { catchError, finalize } from 'rxjs/operators';
import { ErrorStatusMessageModel } from '../entities/error-status-message';
import { Observable, throwError as observableThrowError } from "rxjs";
import { EnrollCompany } from '../entities/enroll-company';

@Injectable({
  providedIn: 'root'
})
export class RegisterService {

  private apiBaseUrl = 'https://api-licenser.freya.cloud/';
  //private apiBaseUrl = 'http://localhost:7664/';

  constructor(private http: HttpClient, public toasterService: ToastrService) { }

  
  public enrollCompany(company: EnrollCompany){
    const apiUrl = this.apiBaseUrl + "Company/EnrollFreyaShop";

    let params = new HttpParams();
    const headers = new HttpHeaders()

    company.ownerUid = '124125235234523';

    return this.http.post<any>(apiUrl, company, { headers, params }).pipe(
      catchError((error: Response) => {
        let displayError = this.displayError2(error);
        this.popErrorToaster(displayError.body, displayError.title);
        return observableThrowError(error || 'SERVER ERROR');
      }),
      finalize(() => {

      })
    );
  }

  public checkCompanyUniqueCode(uniqueCode: string){
    const headers = new HttpHeaders()
    //.set('ApiKey', apiKey);

    const apiUrl = this.apiBaseUrl + 'company/CheckCompanyByUniqueCode';

    let params = new HttpParams();
    params = params.append('uniqueCode', uniqueCode);

    return this.http.get<any>(apiUrl,  { headers, params }).pipe(
      catchError((error: Response) => {
        let displayError = this.displayError2(error);
        this.popErrorToaster(displayError.body, displayError.title);
        return observableThrowError(error || 'SERVER ERROR');
      }),
      finalize(() => {

      })
    );
  }

  public SendSMSCode(phone: string){
    const headers = new HttpHeaders()
    //.set('ApiKey', apiKey);

    const apiUrl = this.apiBaseUrl + 'company/sendSMSCode';

    let params = new HttpParams();
    params = params.append('phone', phone);

    return this.http.get<any>(apiUrl,  { headers, params }).pipe(
      catchError((error: Response) => {
        let displayError = this.displayError(error);
        this.popErrorToaster(displayError.body, displayError.title);
        return observableThrowError(error || 'SERVER ERROR');
      }),
      finalize(() => {

      })
    );
  }

  public validateSMSCode(uid: string, code :string){
    const headers = new HttpHeaders()
    const apiUrl = this.apiBaseUrl + 'company/ValidateSMSCode';

    let params = new HttpParams();
    params = params.append('uid', uid);
    params = params.append('code', code);

    return this.http.get<any>(apiUrl,  { headers, params }).pipe(
      catchError((error: Response) => {
        let displayError = this.displayError(error);
        this.popErrorToaster(displayError.body, displayError.title);
        return observableThrowError(error || 'SERVER ERROR');
      }),
      finalize(() => {

      })
    );
  }

  public popErrorToaster(body: string, title?: string) {
    if (!title) {
      title = 'Code uneditified';
    }
    if (title == "TimeoutError") {
      this.toasterService.warning(body, title);
    } else {
      this.toasterService.error(body, title);
    }
  }

  
  public displayError(error: any): ErrorStatusMessageModel {

    var result = new ErrorStatusMessageModel();
    try {
      result.body = error.error.ErrorMessage;
    } catch {
      result.body = 'Server error';
    }

    try {
      result.title = 'Code: ' + this.getStatus(error);
      if (error.name == "TimeoutError") {
        result.title = error.name;
        result.body = "Procesul dureaza mai mult de 2 minute. Acesta va continua in background.";
      }
    } catch {
      result.title = 'Error';
    }

    return result;
  }

  public displayError2(error: any): ErrorStatusMessageModel {

    var result = new ErrorStatusMessageModel();
    try {
      result.body = error.error.errorMessage;
    } catch {
      result.body = 'Server error';
    }

    try {
      result.title = 'Code: ' + this.getStatus(error);
      if (error.name == "TimeoutError") {
        result.title = error.name;
        result.body = "Procesul dureaza mai mult de 2 minute. Acesta va continua in background.";
      }
    } catch {
      result.title = 'Error';
    }

    return result;
  }
  

  public getStatus(error: any) {
    try {
      return error.error.status;
    } catch { }

    return 'Error';
  }
}
